import { Intersection, Object3D, Vector2 } from 'three';

export class PointerEventData {
  /**
   * Native HTML pointer event
   */
  public pointerEvent: PointerEvent; // Native HTML pointer event

  /**
   * Object 3d considered as the currently selected object by the event system
   */
  public selectedObject: Object3D | undefined;

  /**
   * Raycast result which is associated with the currently selected object
   */
  public selectedObjectRaycast: Intersection = null;

  /**
   * Array of Object 3ds which are hovered over
   */
  public hoveredObjects: Object3D[] = new Array<Object3D>();

  /**
   * Array of Object 3ds which received the POINTER_ENTER event
   */
  public pointerEnterObjects: Object3D[] = new Array<Object3D>();

  /**
   * Array of Object 3ds which received the POINTER_EXIT event
   */
  public pointerLeaveObjects: Object3D[] = new Array<Object3D>();

  /**
   * Pointer delta since last POINTER_MOVE event
   */
  public delta: Vector2 = new Vector2(0, 0);

  /**
   * Is drag operation currently occurring
   */
  public isDragging: boolean;

  /**
   * Pointer current position
   */
  public pointerPosition: Vector2 = new Vector2(0, 0);

  constructor(pointerEvent: PointerEvent) {
    this.pointerEvent = pointerEvent;
    this.delta = new Vector2(0.0, 0.0);
    this.isDragging = false;
    this.selectedObject = null;
    this.hoveredObjects = new Array(0);
    this.pointerEnterObjects = new Array(0);
    this.pointerLeaveObjects = new Array(0);
  }
}
